import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import { backdropAnimation } from "../../helpers/backdrop.animations.js";
import { motion } from "../../../node_modules/framer-motion/dist/es/render/dom/motion.js";
const Backdrop = forwardRef((props, ref) => {
  const { show, onClick, className, ...rest } = props;
  if (!show)
    return null;
  return /* @__PURE__ */ jsx(
    motion.div,
    {
      ...rest,
      ...backdropAnimation,
      ref,
      className: twMerge(
        "fixed top-0 left-0 w-full h-full flex justify-center items-center bg-[var(--backdrop-background-color)]",
        className
      ),
      onClick
    }
  );
});
export {
  Backdrop as default
};
//# sourceMappingURL=Backdrop.js.map
